const theme = {
  background: '#4B4B4B',
  primary: '#0D86DD',
  secondary: '#7FDB1C',
  third: '#FFD700',
  gradientLinear: 'linear-gradient(to right, #FFD700, #FF4500, #9400D3);',
  gradientVertical: 'linear-gradient(180deg, #FFD700, #FF4500, #9400D3);',
  text: '#848DA0',
  textLight: '#C4C4C4',
  textPure: '#FFF',
  border: '#504AAB',
  inputBackground: '#1E253E',
  inputAutoComplete: '#373A77',
};

export default theme;
